import { gql } from '@apollo/client'

import { CardSingleLayout } from '../../../CardSingleLayout/CardSingleLayout'
import { ZellerCardSummaryDisplay } from '../../../DebitCardSummaryDisplay/ZellerCardSummaryDisplay'

export const CardSingleQuery = gql`
  query CardSingleQuery($cardId: ID!) {
    getDebitCardV2(cardId: $cardId) {
      __typename
      productType
      ...CardSingleLayoutDebitCardV2Fragment
      ...ZellerCardSummaryDisplayDebitCardV2Fragment
    }
    getEntity {
      __typename
      id
      canPayByCard
    }
  }

  ${ZellerCardSummaryDisplay.fragments.DebitCardV2}
  ${CardSingleLayout.fragments.DebitCardV2}
`
